import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    minWidth: 0,
    boxSizing: 'border-box',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.padding('20px', '24px'),
    backgroundColor: '#ffffff',
    flexShrink: 0,
    width: '100%',
    boxSizing: 'border-box',
    ...shorthands.gap('16px'),
  },
  headerTop: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#1a1a1a',
  },
  headerControls: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('12px'),
    width: '100%',
  },
  searchBox: {
    width: '300px',
    maxWidth: '100%',
    minWidth: '200px',
  },
  content: {
    flex: 1,
    ...shorthands.padding('0', '24px', '24px', '24px'),
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  section: {
    marginBottom: '32px',
    width: '100%',
    minWidth: 0,
  },
  sectionHeader: {
    ...shorthands.padding('12px', '0'),
    ...shorthands.borderBottom('1px', 'solid', '#e0e0e0'),
    marginBottom: '16px',
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#1a1a1a',
    marginBottom: '4px',
  },
  sectionDescription: {
    fontSize: '13px',
    color: '#666666',
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    ...shorthands.borderRadius('8px'),
    ...shorthands.border('1px', 'solid', '#e0e0e0'),
  },
  table: {
    width: '100%',
    minWidth: '600px',
    backgroundColor: '#ffffff',
    tableLayout: 'auto',
  },
  tableHeader: {
    backgroundColor: '#f8f8f8',
    borderBottom: '1px solid #e0e0e0',
  },
  tableHeaderCell: {
    ...shorthands.padding('12px', '16px'),
    fontSize: '13px',
    fontWeight: '600',
    color: '#666666',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  tableCell: {
    ...shorthands.padding('16px'),
    fontSize: '14px',
    color: '#1a1a1a',
    borderBottom: '1px solid #f0f0f0',
  },
  policyName: {
    fontWeight: '500',
    color: '#0066cc',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  policySubtext: {
    fontSize: '12px',
    color: '#666666',
    marginTop: '2px',
  },
  driftBadge: {
    backgroundColor: '#ff4d4f',
    color: '#ffffff',
  },
  syncBadge: {
    backgroundColor: '#52c41a',
    color: '#ffffff',
  },
  readyBadge: {
    backgroundColor: '#faad14',
    color: '#000000',
  },
  notConfiguredBadge: {
    backgroundColor: '#d9d9d9',
    color: '#666666',
  },
  deletingBadge: {
    backgroundColor: '#ff9800',
    color: '#ffffff',
  },
  policyDeleting: {
    opacity: 0.6,
    cursor: 'not-allowed',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...shorthands.padding('48px'),
  },
  emptyState: {
    textAlign: 'center',
    ...shorthands.padding('48px'),
    color: '#666666',
  },
  assignmentSummary: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('2px'),
  },
  assignmentItem: {
    fontSize: '13px',
    color: '#666666',
  },
  tooltipContent: {
    maxWidth: '300px',
    ...shorthands.padding('8px'),
  },
  tooltipSection: {
    marginBottom: '8px',
    '&:last-child': {
      marginBottom: '0',
    },
  },
  tooltipTitle: {
    fontWeight: '600',
    fontSize: '12px',
    color: '#1a1a1a',
    marginBottom: '4px',
  },
  tooltipList: {
    fontSize: '11px',
    color: '#666666',
    ...shorthands.margin('0'),
    ...shorthands.padding('0', '0', '0', '12px'),
  },
  manageRankTooltipContent: {
    padding: '8px',
  },
  manageRankTooltip: {
    maxWidth: '440px',
  },
  createdPolicyMessageBar: {
    backgroundColor: '#f1faf1',
    ...shorthands.border('1px', 'solid', '#9fd89f'),
    borderRadius: '4px',
  },
  createdPolicyIcon: {
    color: '#237b4b',
    width: '20px',
    height: '20px',
  },
  createdPolicyMessageBody: {
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  createdPolicyMessageText: {
    color: '#242424',
    fontFamily: tokens.fontFamilyBase,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  createdPolicyLink: {
    color: '#115ea3',
    textDecoration: 'underline',
  },
  disclaimerLink: {
    color: '#115ea3',
    textDecoration: 'underline',
  },
});